<template>
    <div class="template-home vertical-layout">
        <HomeVideo/>
        <TopMenuPopup v-if="isMobile && open" @click="closeModalMenu()"/>
        <HeaderMobile v-if="isMobile" @click="openModalMenu()"/>
        <Header v-else/>
        <main>
            <div class="container">
                <div class="info-area">
                    <InfoAreaMobile v-if="isMobile" id="infoAreaId" />
                    <InfoArea v-else id="infoAreaId"/>
                </div>
            </div>
            <div class="products-search-area">
                <div class="gradient-tier"></div>
                <div>
                    <div class="container">
                        <div class="products-area" id="productAreaId">
                            <slot name="products"></slot>
                        </div>
                        <div class="content-area" id="contentAreaId">
                            <slot name="content"></slot>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-footer">
                <slot name="content-footer"></slot>
            </div>
        </main>
        <footer>
            <Footer/>
        </footer>
    </div>
</template>

<script>
import Header from './home/Header'
import HeaderMobile from '../../mobile/pages/layout/home/Header'
import InfoArea from './home/InfoArea'
import InfoAreaMobile from '../../mobile/pages/layout/home/InfoArea'
import Footer from './common/Footer'
import MobileDetector from '../../common/MobileDetector'
import TopMenuPopup from '../../mobile/pages/layout/common/TopMenuPopup'
import HomeVideo from './home/HomeVideo'

export default {
  name: 'HomeLayout',
  mixins: [MobileDetector],
  components: {
    HomeVideo,
    TopMenuPopup,
    Footer,
    Header,
    HeaderMobile,
    InfoArea,
    InfoAreaMobile
  },
  data () {
    return {
      open: false
    }
  },
  methods: {
    openModalMenu () {
      this.open = true
      document.documentElement.style.overflow = 'hidden'
    },
    closeModalMenu () {
      this.open = false
      document.documentElement.style.overflow = 'auto'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/pages/layout/HomeLayout.vue